export const FILE_READ_ERROR = "An error occurred while reading the file :(";
export const UNSUPPORTED_FILE_TYPE = "Unsupported file type";
export const FILE_NOT_SELECTED = "File not selected";
export const RESUME_NOT_UPDATED = "file is not updated yet";
export const RESUME_UPDATED = "Updated Your Resume";
export const RESUME_BUILDER = "Build Your Resume Here"
